'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'classnames';
import NextImage from 'next/image';
import PropTypes from 'prop-types';

import ButtonCTA from 'components/ui/ButtonCTA';
import Text from 'components/ui/Text';

import { blockRootProps, getColor } from 'utils';
import { addProtocol } from 'utils/url';

import styles from './BlockImageNavTile.module.scss';

const Card = ({ title, titleColor, cta, image }) => {
    const hasImage = image?.url;
    const hasCta = cta?.text;
    const color = getColor(titleColor ?? 'cream');
    return (
        <div className={styles.card}>
            {hasImage && (
                <NextImage
                    className={styles.image}
                    src={addProtocol(image.url)}
                    sizes="(max-width: 768px) 100vw, 50vw"
                    width={image.width}
                    height={image.height}
                    alt={image.description || image.title || ''}
                />
            )}
            <div className={styles.content}>
                {title && (
                    <Text
                        as="h3"
                        className={styles.title}
                        style={{ color }}
                        baseTheme="displayXSmall"
                        themes={{
                            medium: 'displayMedium',
                            large: 'displayXSmall',
                            xLarge: 'displayMedium',
                        }}
                    >
                        {title}
                    </Text>
                )}
                {hasCta && <ButtonCTA className={styles.cta} {...cta} />}
            </div>
        </div>
    );
};

Card.propTypes = {
    cta: PropTypes.object,
    image: PropTypes.shape({
        description: PropTypes.string,
        height: PropTypes.number,
        title: PropTypes.string,
        url: PropTypes.string,
        width: PropTypes.number,
    }),
    title: PropTypes.string,
    titleColor: PropTypes.string,
};

const BlockImageNavTile = ({
    __typename,
    anchorId,
    title1,
    titleColor1,
    cta1,
    image1,
    title2,
    titleColor2,
    cta2,
    image2,
    flushTop,
    flushBottom,
}) => {
    return (
        <section
            {...blockRootProps(anchorId, __typename)}
            className={cx(styles.root, {
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
            })}
        >
            <div className={styles.inner}>
                <Card
                    title={title1}
                    titleColor={titleColor1}
                    cta={cta1}
                    image={image1}
                />
                <Card
                    title={title2}
                    titleColor={titleColor2}
                    cta={cta2}
                    image={image2}
                />
            </div>
        </section>
    );
};

BlockImageNavTile.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    flushTop: PropTypes.bool,
    flushBottom: PropTypes.bool,
    cta1: PropTypes.object,
    cta2: PropTypes.object,
    image1: PropTypes.shape({
        description: PropTypes.string,
        height: PropTypes.number,
        title: PropTypes.string,
        url: PropTypes.string,
        width: PropTypes.number,
    }),
    image2: PropTypes.shape({
        description: PropTypes.string,
        height: PropTypes.number,
        title: PropTypes.string,
        url: PropTypes.string,
        width: PropTypes.number,
    }),
    title1: PropTypes.string,
    title2: PropTypes.string,
};

export default BlockImageNavTile;
